import { useTranslate } from "src/i18n";
import { ILink } from "src/types";

export const useOutsourcingPageLinks = (): ILink[] => {
  const { t } = useTranslate();
  return [
    {
      path: "#platforms",
      name: t("outsourcing.header.link.platforms", "Платформы"),
    },
    {
      path: "#platform-comparison",
      name: t(
        "outsourcing.header.link.platforms_comparison",
        "Сравнение платформ",
      ),
    },
    {
      path: "#why-us",
      name: t("outsourcing.header.link.why_us", "Почему мы"),
    },
    {
      path: "#services",
      name: t("outsourcing.header.link.services", "Услуги"),
    },
  ];
};
